// extracted by mini-css-extract-plugin
export default {"onetrust-webform":"one-trust-webform-branded-module--onetrust-webform--24e6c","focus-visible":"one-trust-webform-branded-module--focus-visible--c551b"};